export default __webpack_public_path__ + "static/B22_23_24-19744146861a3c3b421352cfee3781cd.png";